<template>
  <div>
    <RowCard
        :theme="theme"
        class="align-start py-4"
        style="position: relative; min-height: 100px"
    >
      <div :style="{ 'width': headers[0].width }" class="flex-center gap-4">
        <v-btn v-if="item.status === 'Draft' || item.status === 'Inception'" small icon @click="onEdit">
          <Iconify
              icon="material-symbols:edit"
              size="15px"
          ></Iconify>
        </v-btn>
        <v-btn small icon @click="previewFormA">
          <Iconify
              icon="carbon:view-filled"
              size="15px"
          ></Iconify>
        </v-btn>
      </div>
      <div :style="{ 'width': headers[1].width }" :class="{ 'theme-color-seven': redText }">{{ index + 1 }}</div>
      <div :style="{ 'width': headers[2].width }" :class="{ 'theme-color-seven': redText }">{{ item.main_project?.fiscal_year }}</div>
      <div :style="{ 'width': headers[3].width }" :class="{ 'theme-color-seven': redText }">
        <div class="one-line mb-5" :class="[ redText ? 'theme-color-seven' : 'black--text' ]" style="height: 20px">
          {{ item.main_project?.name }}
        </div>
        <div v-if="item.main_project?.start_date && item.main_project?.end_date" class="one-line font-type-normal">
          ระยะเวลาเปิดรับโครงการ : {{ toDateRangeFormat(item.main_project.start_date, item.main_project.end_date) }}
        </div>
      </div>
      <div
          :style="{ 'width': headers[4].width }"
      >
        {{ item.region }}
      </div>
      <div
          :style="{ 'width': headers[5].width, 'color': statusColorSeparator(item.status) }"
      >{{ item.status }}</div>
      <div
          :style="{ 'width': headers[6].width }"
      >

      </div>

      <v-btn
          absolute
          top
          right
          icon
          :class="{ 'rotate180': isExpanded }"
          @click="seeDetail"
      >
        <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between gap-12 theme-color-eight">
          <div style="min-width: 8%; max-width: 8%"></div>
          <div style="min-width: 62%; max-width: 62%">แผนงาน</div>
          <div style="min-width: 30%; max-width: 30%">สถานะ</div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div v-if="item.main_project && item.main_project.plan" class="d-flex flex-column gap-8">
          <div
              v-for="(x, i) in item.main_project.plan"
              :key="i"
          >
            <div class="d-flex justify-space-between align-center gap-12">
              <div style="min-width: 8%; max-width: 8%">
                <v-btn v-if="x.form_b" small icon @click="editFormB(x.form_b.id)">
                  <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                      size="15px"
                  ></Iconify>
                </v-btn>
                <v-btn small icon v-if="x.form_b" @click="previewFormB(x.form_b.id)">
                  <Iconify
                      icon="carbon:view-filled"
                      color="var(--theme-color-seven)"
                      size="15px"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="min-width: 62%; max-width: 62%">
                {{ x.plan_master?.plan_name_th }}
              </div>
              <div style="min-width: 30%; max-width: 30%">
                <div v-if="x.form_b">
                  {{ x.form_b.status }}
                </div>

                <Button
                    v-else
                    height="36px"
                    theme="3"
                    @onClick="createBForm(x.id)"
                >
                  สร้างฟอร์ม B
                </Button>
              </div>
            </div>
          </div>

          <div v-if="item.status === 'Approved'" class="d-flex align-center gap-12">
            <Button
                @onClick="extendRequest"
            >
              ยื่นขอขยายเวลา
            </Button>

            <Button
                @onClick="progressReport"
            >
              รายงานความก้าวหน้า
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button"
import RowCard from "../components/RowCard"
import { toDateRangeFormat } from "../plugins/global-funcs"

export default {
  name: "MainProjectOfferItem",
  components: {
    Button,
    RowCard
  },
  props: {
    item: {
      default: () => ({})
    },
    index: {
      default: 0
    },
    headers: {
      default: () => ([])
    }
  },
  data () {
    return {
      toDateRangeFormat,
      rand: 'cl-' + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false
    }
  },
  methods: {
    seeDetail () {
      let growDiv = document.querySelector('.' + this.rand + '.expand-layout')
      if (growDiv.clientHeight) {
        growDiv.style.height = 0
        this.isExpanded = false
      } else {
        let wrapper = document.querySelector('.' + this.rand + ' .expand-content')
        growDiv.style.height = (wrapper.clientHeight + 20) + "px"
        this.isExpanded = true
      }
    },
    statusColorSeparator (status) {
      switch (status) {
        case 'Draft':
          this.theme = 2
          this.redText = true
          return 'var(--theme-color-seven)'

        case 'Submitted1':
          this.theme = 5
          return 'var(--theme-color-five)'

        case 'Rejected':
          this.theme = 4
          return 'var(--theme-color-four)'

        case 'Submitted2':
          this.theme = 10
          return 'var(--theme-color-ten)'

        case 'Approved':
        case 'Inception':
          this.theme = 3
          return 'var(--theme-color-three)'

        default:
          return 'var(--theme-color-two)'
      }
    },
    onEdit () {
      this.$router.push({ name: 'FormA', query: { id: this.item.id } })
    },
    previewFormA () {
      this.$router.push({ name: 'FormA', query: { id: this.item.id, preview: true } })
    },
    createBForm (id) {
      this.$router.push({ name: 'FormB', query: { form_a_id: this.item.id, plan_id: id } })
    },
    editFormB (id) {
      this.$router.push({ name: 'FormB', query: { id: id } })
    },
    previewFormB (id) {
      this.$router.push({ name: 'FormB', query: { id: id, preview: true } })
    },
    extendRequest () {

    },
    async progressReport () {
      let res = await this.$apiFire('AForm/storeNewProgressFormA', this.item.id)
      if (typeof res === "number") {
        this.$router.push({ name: 'FormA', query: { id: res, doc_type: 'progress' } })
      }
    }
  }
}
</script>

<style scoped>
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height .2s;
  -ms-transition: height .2s;
  -o-transition: height .2s;
  -webkit-transition: height .2s;
  transition: height .2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #FAFAFA;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>